var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14061_10734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6553 12.5947C13.3624 12.3018 12.8876 12.3018 12.5947 12.5947C12.3018 12.8876 12.3018 13.3624 12.5947 13.6553L13.125 13.125L13.6553 12.5947ZM13.125 13.125L12.5947 13.6553L15.9697 17.0303L16.5 16.5L17.0303 15.9697L13.6553 12.5947L13.125 13.125ZM15 8.25H15.75C15.75 4.10786 12.3921 0.75 8.25 0.75V1.5V2.25C11.5637 2.25 14.25 4.93629 14.25 8.25H15ZM8.25 1.5V0.75C4.10786 0.75 0.75 4.10786 0.75 8.25H1.5H2.25C2.25 4.93629 4.93629 2.25 8.25 2.25V1.5ZM1.5 8.25H0.75C0.75 12.3921 4.10786 15.75 8.25 15.75V15V14.25C4.93629 14.25 2.25 11.5637 2.25 8.25H1.5ZM8.25 15V15.75C12.3921 15.75 15.75 12.3921 15.75 8.25H15H14.25C14.25 11.5637 11.5637 14.25 8.25 14.25V15Z",
    fill: "#302F2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14061_10734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9fce1ba2ed5fb2294711fe269eeaf534.svg";
export { ForwardRef as ReactComponent };